import {
  Button,
  ButtonGroup,
  ContainerFooter,
} from '@frontend/legacy-components';

type FormActionsProps = {
  onCancel: () => void;
  isValid: boolean;
  isSubmitting: boolean;
  cancelLabel?: string;
  submitLabel?: string;
  size?: 'sm' | 'md' | 'lg';
};

export const FormActions = ({
  onCancel,
  isValid,
  isSubmitting,
  cancelLabel = 'Cancel',
  submitLabel = 'Submit',
  size = 'sm',
}: FormActionsProps) => {
  return (
    <ContainerFooter justifyContent="flex-end">
      <ButtonGroup>
        <Button variant="secondary" size={size} onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button
          type="submit"
          size={size}
          isDisabled={!isValid}
          isLoading={isSubmitting}
        >
          {submitLabel}
        </Button>
      </ButtonGroup>
    </ContainerFooter>
  );
};
